import React from "react";
import MyBet from "../../casinoComponents/myBet";

/** Color Plus payouts shown by the reference RightSideBar (from its casino/rules API) for 29Card Baccarat. */
const COLOR_PLUS_RULES = [
  ["Straight", "1 TO 2"],
  ["Flush", "1 TO 5"],
  ["Trio", "1 TO 20"],
  ["Straight Flush", "1 TO 30"],
];

// Reference markup: .card.m-b-10 > .card-header > h6.card-title.d-inline-block "Rules"
//   + .card-body(padding 10px) > table.table.table-bordered.rules-table
function TeensinRulesCard() {
  return (
    <div className="card m-b-10">
      <div className="card-header">
        <h6 className="card-title d-inline-block">{"\n          Rules\n          "}</h6>
      </div>{" "}
      <div className="card-body" style={{ padding: "10px" }}>
        <table className="table table-bordered rules-table">
          <tbody>
            <tr className="text-center">
              <th colSpan={2}>Color Plus Rules</th>
            </tr>
            {COLOR_PLUS_RULES.map(([nat, val]) => (
              <tr key={nat}>
                <td width="60%">{nat}</td>
                <td>{val}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/** Right sidebar for 29Card Baccarat: My Bets + Color Plus Rules card. */
export default function TeensinRightSide({ bets, onViewMore }) {
  return (
    <>
      <MyBet bets={bets} onViewMore={onViewMore} />{" "}
      <TeensinRulesCard />
    </>
  );
}
